module.exports = ".forgot-password-link {\r\n    float: right !important;\r\n    margin-right: -38px;\r\n    font-weight: 700;\r\n    margin-top: 32px;\r\n    margin-bottom: -50px;\r\n        cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n\r\n.alert-error{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.component.css
// module id = ./src/app/components/login/login.component.css
// module chunks = main